import "./styles.css";
import React from "react";
import FormControl from "@mui/material/FormControl";
import { InputBase, MenuItem, Select } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function DropdownPicker({
  registrationTypes,
  selectedType = "",
  handleChange,
  searchable,
  searchText,
  onSearch,
  title,
}) {
  return (
    <div className="dropdown" id="dropdown-picker-container">
      {title && (
        <p className="leave-type-title" id="dropdown-picker-title">
          {title}
        </p>
      )}
      <FormControl
        sx={{ width: "100%", mt: searchable ? 0 : 3 }}
        id="dropdown-picker-from-control"
      >
        <Select
          value={selectedType}
          onChange={handleChange}
          renderValue={(selected) => {
            return selected;
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
          id="dropdown-picker-selector"
        >
          {searchable && (
            <MenuItem id="dropdown-picker-menu-item-search">
              <InputBase
                onChange={onSearch}
                value={searchText}
                style={{ border: "1px solid rgba(169,169,169)" }}
                className="search"
                id="dropdown-picker-search-item"
              />
            </MenuItem>
          )}
          {registrationTypes.map((registration) => (
            <MenuItem
              key={searchable ? registration.name : registration}
              value={searchable ? registration.name : registration}
              id="dropdown-picker-menu-item"
            >
              {searchable ? registration.name : registration}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
